import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import s from './AuthLayout.module.css';

interface AuthLayoutProps {
  pitchTitle: ReactNode;
  pitchBody: string;
  children: ReactNode;
}

export function AuthLayout({ pitchTitle, pitchBody, children }: AuthLayoutProps): JSX.Element {
  return (
    <div className={s.root}>
      <aside className={s.aside}>
        <Link to="/" className={s.brand}>
          <span className={s.brandMark} aria-hidden="true">
            i
          </span>
          IELTS Mock Platform
        </Link>
        <div className={s.pitch}>
          <h2 className={s.pitchTitle}>{pitchTitle}</h2>
          <p className={s.pitchBody}>{pitchBody}</p>
        </div>
        <div className={s.footnote}>
          <span className={s.footRow}>
            <span className={s.footDot} aria-hidden="true" />
            Listening · Reading · Writing · Speaking
          </span>
          <span className={s.footRow}>
            <span className={s.footDot} aria-hidden="true" />
            Real exam timing, real band feedback
          </span>
          <span className={s.footRow}>
            <span className={s.footDot} aria-hidden="true" />
            Trusted by IELTS coaching institutes
          </span>
        </div>
      </aside>
      <main className={s.main}>
        <Link to="/" className={s.mobileBrand}>
          <span className={s.mobileBrandMark} aria-hidden="true">
            i
          </span>
          IELTS Mock Platform
        </Link>
        <div className={s.formWrap}>{children}</div>
      </main>
    </div>
  );
}
